module.exports = __webpack_public_path__ + "static/media/brokoli-big.8d1e2257.png";